import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './PageStyles.css';

const ManuelPage = () => {
  const [activeComparison, setActiveComparison] = useState(0);

  const comparisons = [
    {
      title: "Disponibilité 24h/24 vs 8h/jour",
      description: "Un employé humain travaille 8h par jour, 5 jours par semaine. Notre IA fonctionne 24h/24, 7j/7, 365 jours par an. Vos clients peuvent prendre rendez-vous à 3h du matin, le dimanche ou les jours fériés. Aucun employé ne peut offrir cette disponibilité."
    },
    {
      title: "Zéro erreur vs Erreurs humaines", 
      description: "Un employé peut oublier un rendez-vous, faire une erreur de saisie, ou mal comprendre une demande. L'IA ne fait jamais d'erreur, ne se trompe jamais de date, et traite chaque demande avec la même précision parfaite."
    },
    {
      title: "Réponse instantanée vs Délais",
      description: "Un employé met du temps à répondre : vérifier l'agenda, appeler le client, négocier un créneau. L'IA répond en millisecondes. Votre client obtient immédiatement ses créneaux disponibles, sans attente, sans frustration."
    },
    {
      title: "Coût fixe vs Salaire + charges",
      description: "Un employé coûte un salaire mensuel, des charges sociales, des congés payés, des arrêts maladie, des formations. L'IA a un coût fixe, prévisible, sans surprise. Vous savez exactement ce que vous payez chaque mois."
    }
  ];

  return (
    <div className="page-container">
      <div className="page-content">
        {/* Header */}
        <div className="page-header">
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem'}}>
            <Link to="/" style={{fontSize: '1.5rem', fontWeight: '700', color: '#60a5fa', textDecoration: 'none'}}>
              Monagora
            </Link>
            <Link to="/" style={{color: '#cbd5e1', textDecoration: 'none', fontSize: '0.9rem'}}>
              ← Retour à l'accueil
            </Link>
          </div>
          
          <div style={{textAlign: 'center', marginBottom: '1rem'}}>
            <span style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              background: 'rgba(16, 185, 129, 0.1)',
              color: '#10b981',
              padding: '0.5rem 1rem',
              borderRadius: '50px',
              fontSize: '0.9rem',
              fontWeight: '600',
              border: '1px solid rgba(16, 185, 129, 0.3)'
            }}>
              IA vs Employé Humain
            </span>
          </div>
          
          <h1 className="page-title">
            Pourquoi l'IA Surpasse un Employé
          </h1>
          <p className="page-subtitle">
            Découvrez pourquoi notre intelligence artificielle est plus efficace, 
            plus fiable et plus économique qu'un employé humain pour gérer vos plannings.
          </p>
        </div>

        {/* Section principale avec comparaison IA vs Humain */}
        <div className="page-section">
          <h2 className="section-title">Comparaison Directe</h2>
          
          <div className="section-content">
            <div className="content-text">
              <h3 style={{color: '#10b981', fontSize: '1.8rem', marginBottom: '2rem'}}>
                L'IA : Votre Employé Parfait
              </h3>
              
              <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
                <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
                  <span style={{
                    width: '8px',
                    height: '8px',
                    background: '#10b981',
                    borderRadius: '50%',
                    flexShrink: 0
                  }}></span>
                  <span style={{color: '#e2e8f0'}}>Jamais malade, jamais en congé</span>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
                  <span style={{
                    width: '8px',
                    height: '8px',
                    background: '#10b981',
                    borderRadius: '50%',
                    flexShrink: 0
                  }}></span>
                  <span style={{color: '#e2e8f0'}}>Toujours de bonne humeur</span>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
                  <span style={{
                    width: '8px',
                    height: '8px',
                    background: '#10b981',
                    borderRadius: '50%',
                    flexShrink: 0
                  }}></span>
                  <span style={{color: '#e2e8f0'}}>N'oublie jamais un rendez-vous</span>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
                  <span style={{
                    width: '8px',
                    height: '8px',
                    background: '#10b981',
                    borderRadius: '50%',
                    flexShrink: 0
                  }}></span>
                  <span style={{color: '#e2e8f0'}}>Ne prend jamais de pause café</span>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
                  <span style={{
                    width: '8px',
                    height: '8px',
                    background: '#10b981',
                    borderRadius: '50%',
                    flexShrink: 0
                  }}></span>
                  <span style={{color: '#e2e8f0'}}>Ne demande jamais d'augmentation</span>
                </div>
                <div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
                  <span style={{
                    width: '8px',
                    height: '8px',
                    background: '#10b981',
                    borderRadius: '50%',
                    flexShrink: 0
                  }}></span>
                  <span style={{color: '#e2e8f0'}}>S'améliore avec le temps</span>
                </div>
              </div>
            </div>
            
            <div className="content-visual">
              <div className="comparison-chart">
                <div className="chart-header">
                  <div className="chart-title">IA vs Employé Humain</div>
                  <div className="chart-subtitle">Comparaison objective</div>
                </div>
                
                <div className="comparison-bars">
                  <div className="comparison-bar-group">
                    <div className="comparison-bar-label">Disponibilité</div>
                    <div className="comparison-bar-container">
                      <div className="comparison-bar ia-bar" style={{
                        height: '120px',
                        background: 'linear-gradient(to top, #10b981, #059669)',
                        position: 'relative'
                      }}>
                        <span className="comparison-bar-value">24h/24</span>
                      </div>
                      <div className="comparison-bar human-bar" style={{
                        height: '40px',
                        background: 'linear-gradient(to top, #ef4444, #dc2626)',
                        position: 'relative'
                      }}>
                        <span className="comparison-bar-value">8h/jour</span>
                      </div>
                    </div>
                    <div className="comparison-legend">
                      <span style={{color: '#10b981'}}>IA</span>
                      <span style={{color: '#ef4444'}}>Humain</span>
                    </div>
                  </div>
                  
                  <div className="comparison-bar-group">
                    <div className="comparison-bar-label">Précision</div>
                    <div className="comparison-bar-container">
                      <div className="comparison-bar ia-bar" style={{
                        height: '100px',
                        background: 'linear-gradient(to top, #10b981, #059669)',
                        position: 'relative'
                      }}>
                        <span className="comparison-bar-value">100%</span>
                      </div>
                      <div className="comparison-bar human-bar" style={{
                        height: '85px',
                        background: 'linear-gradient(to top, #ef4444, #dc2626)',
                        position: 'relative'
                      }}>
                        <span className="comparison-bar-value">Limité</span>
                      </div>
                    </div>
                    <div className="comparison-legend">
                      <span style={{color: '#10b981'}}>IA</span>
                      <span style={{color: '#ef4444'}}>Humain</span>
                    </div>
                  </div>
                  
                  <div className="comparison-bar-group">
                    <div className="comparison-bar-label">Coût/Mois</div>
                    <div className="comparison-bar-container">
                      <div className="comparison-bar ia-bar" style={{
                        height: '30px',
                        background: 'linear-gradient(to top, #10b981, #059669)',
                        position: 'relative'
                      }}>
                        <span className="comparison-bar-value">299€</span>
                      </div>
                      <div className="comparison-bar human-bar" style={{
                        height: '120px',
                        background: 'linear-gradient(to top, #ef4444, #dc2626)',
                        position: 'relative'
                      }}>
                        <span className="comparison-bar-value">2500€</span>
                      </div>
                    </div>
                    <div className="comparison-legend">
                      <span style={{color: '#10b981'}}>IA</span>
                      <span style={{color: '#ef4444'}}>Humain</span>
                    </div>
                  </div>
                </div>
                
                <div className="comparison-summary">
                  <div className="comparison-highlight">
                    <span className="comparison-percentage">-88%</span>
                    <span className="comparison-label">de coût par rapport à un employé</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Section comparaisons détaillées */}
        <div className="page-section">
          <h2 className="section-title">Pourquoi l'IA Est Supérieure</h2>
          
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1.5fr', gap: '4rem', alignItems: 'flex-start'}}>
            {/* Colonne de gauche - Titres courts */}
            <div style={{display: 'flex', flexDirection: 'column', gap: '1rem'}}>
              {comparisons.map((comparison, index) => (
                <div
                  key={index}
                  style={{
                    padding: '1.5rem 2rem',
                    background: activeComparison === index 
                      ? 'rgba(16, 185, 129, 0.15)' 
                      : 'rgba(255, 255, 255, 0.05)',
                    backdropFilter: 'blur(15px)',
                    borderRadius: '12px',
                    border: activeComparison === index 
                      ? '2px solid rgba(16, 185, 129, 0.3)' 
                      : '1px solid rgba(255, 255, 255, 0.1)',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    overflow: 'hidden'
                  }}
                  onMouseEnter={() => setActiveComparison(index)}
                >
                  {/* Indicateur visuel à gauche */}
                  <div style={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    width: activeComparison === index ? '4px' : '0px',
                    background: 'linear-gradient(135deg, #10b981, #059669)',
                    transition: 'width 0.3s ease'
                  }}></div>
                  
                  <h3 style={{
                    color: activeComparison === index ? '#10b981' : '#f1f5f9',
                    fontSize: '1.1rem',
                    fontWeight: '600',
                    margin: 0,
                    transition: 'color 0.3s ease',
                    transform: activeComparison === index ? 'scale(1.02)' : 'scale(1)',
                    transformOrigin: 'left center'
                  }}>
                    {comparison.title}
                  </h3>
                </div>
              ))}
            </div>
            
            {/* Colonne de droite - Détails */}
            <div style={{
              padding: '3rem',
              background: 'rgba(255, 255, 255, 0.08)',
              backdropFilter: 'blur(20px)',
              borderRadius: '20px',
              border: '1px solid rgba(255, 255, 255, 0.15)',
              minHeight: '300px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              boxShadow: '0 20px 50px rgba(0, 0, 0, 0.3)',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '3px',
                background: 'linear-gradient(135deg, #10b981, #059669)',
                opacity: 0.8
              }}></div>
              
              <h3 style={{
                color: '#10b981',
                fontSize: '1.8rem',
                fontWeight: '700',
                marginBottom: '1.5rem',
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
              }}>
                {comparisons[activeComparison].title}
              </h3>
              
              <p style={{
                color: '#e2e8f0',
                fontSize: '1.1rem',
                lineHeight: '1.7',
                margin: 0,
                textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)'
              }}>
                {comparisons[activeComparison].description}
              </p>
            </div>
          </div>
        </div>

        {/* Section métriques de comparaison */}
        <div className="page-section">
          <h2 className="mode-page-hero-main-title-heading">L'IA en Chiffres</h2>
          
          <div className="metrics-grid">
            <div className="metric-item">
              <span className="metric-number">24h/24</span>
              <span className="metric-label">Disponibilité</span>
            </div>
            
            <div className="metric-item">
              <span className="metric-number">100%</span>
              <span className="metric-label">Précision</span>
            </div>
            
            <div className="metric-item">
              <span className="metric-number">0€</span>
              <span className="metric-label">Charges sociales</span>
            </div>
            
            <div className="metric-item">
              <span className="metric-number">0</span>
              <span className="metric-label">Jours de congé</span>
            </div>
          </div>
        </div>

        {/* Section avantages spécifiques de l'IA */}
        <div className="page-section">
          <h2 className="mode-page-hero-main-title-heading">Avantages Exclusifs de l'IA</h2>
          
          <div className="feature-grid">
            <div className="feature-card">
              <div className="feature-icon" style={{background: 'linear-gradient(135deg, #10b981, #059669)', borderRadius: '12px', width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', color: 'white', marginBottom: '1.5rem'}}>
                ⚡
              </div>
              <h3>Réponse Instantanée</h3>
              <p>
                L'IA répond en millisecondes, pas en heures. Vos clients obtiennent 
                immédiatement leurs créneaux disponibles.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon" style={{background: 'linear-gradient(135deg, #10b981, #059669)', borderRadius: '12px', width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', color: 'white', marginBottom: '1.5rem'}}>
                🧠
              </div>
              <h3>Apprentissage Continu</h3>
              <p>
                L'IA s'améliore chaque jour en analysant vos préférences. 
                Un employé reste au même niveau.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon" style={{background: 'linear-gradient(135deg, #f59e0b, #d97706)', borderRadius: '12px', width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', color: 'white', marginBottom: '1.5rem'}}>
                💰
              </div>
              <h3>Coût Prévisible</h3>
              <p>
                Prix fixe mensuel, pas de surprise. Pas de congés payés, 
                pas de charges sociales, pas d'augmentation.
              </p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon" style={{background: 'linear-gradient(135deg, #6366f1, #4f46e5)', borderRadius: '12px', width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', color: 'white', marginBottom: '1.5rem'}}>
                🔄
              </div>
              <h3>Scalabilité Infinie</h3>
              <p>
                L'IA gère 10 ou 1000 clients sans problème. 
                Un employé a ses limites physiques et mentales.
              </p>
            </div>
          </div>
        </div>

        {/* Navigation vers autres pages */}
        <div className="page-section" style={{borderBottom: 'none'}}>
          <h2 className="mode-page-hero-main-title-heading">Découvrez Nos Autres Avantages</h2>
          
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem', marginTop: '2rem'}}>
            <Link to="/automatique" style={{textDecoration: 'none'}}>
              <div className="feature-card" style={{cursor: 'pointer', transition: 'all 0.3s ease'}}>
                <div className="feature-icon" style={{background: 'linear-gradient(135deg, #60a5fa, #3b82f6)', borderRadius: '12px', width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', color: 'white', marginBottom: '1.5rem'}}>
                  ⏰
                </div>
                <h3 style={{color: '#60a5fa'}}>Temps Récupéré</h3>
                <p>
                  Découvrez comment l'automatisation vous fait gagner 3h par jour
                </p>
                <div style={{marginTop: '1rem', color: '#60a5fa', fontWeight: '600'}}>
                  Découvrir →
                </div>
              </div>
            </Link>
            
            <Link to="/gains-financiers" style={{textDecoration: 'none'}}>
              <div className="feature-card" style={{cursor: 'pointer', transition: 'all 0.3s ease'}}>
                <div className="feature-icon" style={{background: 'linear-gradient(135deg, #10b981, #059669)', borderRadius: '12px', width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', color: 'white', marginBottom: '1.5rem'}}>
                  💰
                </div>
                <h3 style={{color: '#10b981'}}>Gains Financiers</h3>
                <p>
                  Calculez vos économies réelles avec notre solution
                </p>
                <div style={{marginTop: '1rem', color: '#10b981', fontWeight: '600'}}>
                  Découvrir →
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManuelPage; 